'use client';

import React, { memo, useEffect, useMemo, useState } from 'react';
import { SpaFooterContext } from '@chewy/header-footer-react/dist/components/react/src/footer/spa/spa-footer.context';
import { SpaComponentPropsResponse, getSpaComponentProps } from '@chewy/header-footer-react/dist/common/spa/spa.util';
import { SpaFooter } from '@chewy/header-footer-react/dist/components/react/src/footer/spa/spa-footer';
import { SOURCE_FOOTER_COMPONENT_PROPS_REQUEST } from '../utils/config/constants';
import useEnv from '@/hooks/useEnv';

const ClientFooter = () => {
  const [footerProps, setFooterProps] = useState<SpaComponentPropsResponse | null>(null);
  const { chewyEnv, headerFooterSpaUrl } = useEnv();

  // Create the footer request with runtime config
  const footerRequest = useMemo(
    () => ({
      ...SOURCE_FOOTER_COMPONENT_PROPS_REQUEST,
      baseURL: headerFooterSpaUrl || 'https://www.chewy.com/app/headerfooterspa'
    }),
    [headerFooterSpaUrl]
  );

  const contextValue = useMemo(
    () => ({
      baseURL: headerFooterSpaUrl || 'https://www.chewy.com/app/headerfooterspa',
      env: chewyEnv,
      pageType: 'home',
      mountElemId: 'footer'
    }),
    [chewyEnv, headerFooterSpaUrl]
  );

  useEffect(() => {
    (async () => {
      const props = (await getSpaComponentProps(footerRequest)) as SpaComponentPropsResponse;
      setFooterProps(props);
    })();
  }, [footerRequest]);

  return (
    footerProps && (
      <>
        <div id="footer" data-testid="footer" />
        <SpaFooterContext.Provider value={contextValue}>
          <SpaFooter css={footerProps?.css ?? ''} html={footerProps?.html ?? ''} js={footerProps?.js ?? ''} csr={footerProps?.csr ?? true} />
        </SpaFooterContext.Provider>
      </>
    )
  );
};

export default memo(ClientFooter);
